import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Heart, ArrowRight } from 'lucide-react';
import { img, labelize, PrimaryButton, GhostButton, cx } from './ui';
import { useInquiryCart } from '../../../context/InquiryCartContext';
import { useWishlist } from '../../../context/WishlistContext';

export default function QuickViewModal({ product, onClose }) {
  const { addItem, openCart } = useInquiryCart();
  const wishlist = useWishlist();

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!product) return null;
  const saved = wishlist.has(product.id);

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label={product.name}>
      <div className="absolute inset-0 bg-[#160f0a99] backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-3xl bg-[#f4ece0] shadow-2xl grid md:grid-cols-2 max-h-[90vh] overflow-hidden">
        <button
          onClick={onClose}
          aria-label="Close quick view"
          className="absolute top-3 right-3 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-[#f4ece0e6] hover:bg-white"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="bg-[#ece0cd] aspect-[4/5] md:aspect-auto">
          <img src={img(product.image_url)} alt={product.name} className="w-full h-full object-cover" />
        </div>
        <div className="p-7 overflow-y-auto">
          {product.category && (
            <div className="text-[10.5px] uppercase tracking-[0.2em] text-[#b5622f] mb-2">
              {labelize(product.category)}
            </div>
          )}
          <h3 className="font-display text-2xl leading-snug">{product.name}</h3>
          {product.description && (
            <p className="text-[14px] text-[#4a3d32] mt-4 leading-relaxed">{product.description}</p>
          )}

          <div className="mt-7 flex flex-col gap-3">
            <PrimaryButton onClick={() => { addItem(product, 1); openCart(); onClose(); }} className="w-full">
              Add to inquiry
            </PrimaryButton>
            <div className="flex gap-3">
              <GhostButton to={`/products/${product.slug}`} onClick={onClose} className="flex-1">
                Full details <ArrowRight className="w-4 h-4" />
              </GhostButton>
              <button
                onClick={() => wishlist.toggle(product.id)}
                aria-pressed={saved}
                aria-label={saved ? 'Remove from wishlist' : 'Save to wishlist'}
                className={cx(
                  'w-12 flex items-center justify-center border transition-colors',
                  saved ? 'border-[#b5622f] text-[#b5622f]' : 'border-[#241811]/25 text-[#241811] hover:border-[#241811]'
                )}
              >
                <Heart className="w-4 h-4" fill={saved ? 'currentColor' : 'none'} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
